import getSubdomain from '@/common/getSubdomain';

export default function useIsSsoSurf(): boolean {
  const ssoSubDomains = import.meta.env.VITE_SSO_SURF_SUBDOMAINS.split(',');
  const subDomein = getSubdomain();
  return subDomein && ssoSubDomains.includes(subDomein);
}
